import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
//import {ShopApplicationPopupV2} from "./ShopApplicationPopupV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {Link} from "react-router-dom";
import {serviceFormat} from "../../../static/js/service/formatService";
import {subNavEvent} from "../../../static/js/service/commonService";

export default function  ShopApplicationV2() {
  const [shopList, setShopList] = useState([]);

  useEffect(() => {
    subNavEvent("shopNav", "shop4");
  }, []);

  const formatApprovalTpcd = (getStatus1, getStatus2) => {
    let approvalTpcd = '';

    switch (getStatus1) {
      case 1:
        approvalTpcd = '1차 승인대기';
        break;
      case 2:
        approvalTpcd = '1차 보류';
        break;
      case 6:
        approvalTpcd = '입점불가';
        break;
      case 4:
        switch (getStatus2) {
          case 1:
            approvalTpcd = '2차 승인대기';
            break;
          case 2:
            approvalTpcd = '2차 보류';
            break;
          case 3:
            approvalTpcd = '2차 등록요청완료';
            break;
          case 5:
            approvalTpcd = '입점완료';
            break;
          case 6:
            approvalTpcd = '입점불가';
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }

    return approvalTpcd;
  };

  const items = shopList.map((value, index) => {
    const approvalTpcd = formatApprovalTpcd(value.approvalTpcd1, value.approvalTpcd2);

    return (
      <div className="tableInfoBody bg-white d-flex pt-15 pb-15" key={index}>
        <div className="d-flex a-center j-center" style={{width:'103px'}}>{index + 1}</div>
        <div className="d-flex a-center j-center" style={{width:'calc(100% - 765px)'}}>{ value.storeName }</div>
        <div className="d-flex a-center j-center" style={{width:'135px'}}>{serviceFormat(value.serviceTpcd)}</div>
        <div className="d-flex a-center j-center" style={{width:'135px'}}>{approvalTpcd}</div>
        <div className="d-flex a-center j-center" style={{width:'216px'}}>{value.createTs.substr(0, 10)}</div>
        <div className='d-flex a-center j-center fs-18 fc-gray' style={{width:'176px'}}>
          <Link to={`/v2/shopDetail/${value.id}`}>상세보기  &gt;</Link>
        </div>
      </div>
    );
  });

  return (
    <main id="shopV2" className="mainV2">
      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 신청 현황" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 신청 현황" countText="전체 상점 총 " count={shopList.length} unit="개" />
          </div>

          <div id="shopSelectBox" className="hide">
            <ShopSelectBoxV2 url="/v2/shopAppList" setShopList={setShopList} />
          </div>

          <div className="tableInfoBox mb-50">
            <div className='tableInfoHead d-flex bg-blue fc-white ta-center pt-15 pb-15'>
              <div className="d-flex a-center j-center" style={{width:'103px'}}>No</div>
              <div className="d-flex a-center j-center" style={{width:'calc(100% - 765px)'}}>상점명</div>
              <div className="d-flex a-center j-center" style={{width:'135px'}}>서비스</div>
              <div className="d-flex a-center j-center" style={{width:'135px'}}>상태</div>
              <div className="d-flex a-center j-center" style={{width:'216px'}}>신청일</div>
              <div className="d-flex a-center j-center" style={{width:'176px'}}></div>
            </div>
            {items}
          </div>
        </section>
      </div>
    </main>
  )
}